import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataToSendDichiarazione } from '../../dischiarazione.models';

@Component({
    selector: 'app-dettagli-acconto-versato',
    templateUrl: './dettagli-acconto-versato.component.html',
    styleUrls: ['./dettagli-acconto-versato.component.scss'],
})
export class DettagliAccontoVersatoComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DettagliAccontoVersatoComponent>,
        @Inject(MAT_DIALOG_DATA)
        public dettagliAccontiVersati: { cellId: string; dataToSendDichiarazione: DataToSendDichiarazione }
    ) {}

    ngOnInit() {}

    ngOnDestroy(): void {}
}
